import React, { FC, useEffect } from "react";
import { useSelector } from "react-redux";
import { RootState } from "@store/store";
import { useNavigate } from "react-router-dom";
import { useGetPatientQuery } from "@store/patientApi";
import Loader from "@components/Loader/Loader";
import OnboardingForm from "@components/Onboarding/OnboardingForm/OnboardingForm";
import { useTranslation } from "react-i18next";
import OnboardingCharactersForm from "@components/Onboarding/OnboardingCharacterForm/OnboardingCharactersForm";
import PortraitIcon from "@mui/icons-material/Portrait";

const Characters: FC = () => {
  const patientId = useSelector(
    (state: RootState) => state.home.selectedPatientId,
  );
  const accountId = useSelector((state: RootState) => state.account.accountId);
  const navigate = useNavigate();
  const { data: patient, isLoading } = useGetPatientQuery(patientId!, {
    skip: !patientId,
  });
  const { t } = useTranslation();

  useEffect(() => {
    if (!accountId) {
      navigate("/onboarding");
    } else if (!patient && !isLoading) {
      navigate("/onboarding/profile");
    }
  }, [patient, accountId, navigate, isLoading]);

  return (
    <>
      {isLoading || !patient ? (
        <Loader />
      ) : (
        <OnboardingForm
          title={t("characters.title")}
          subtitle={t("characters.subtitle", {
            patientNickName: patient?.nickname || patient?.firstName || "",
          })}
          icon={<PortraitIcon fontSize="small" />}
        >
          <OnboardingCharactersForm patient={patient} />
        </OnboardingForm>
      )}
    </>
  );
};

export default Characters;
